// Live search and paging over a rendered table.
//
// This replaces DataTables, which the app carried — plugin, Bootstrap 4 theme,
// stylesheet import and a vendored Slovenian locale — for exactly one table,
// users/index. Everything else it offered was either unused (server-side paging,
// AJAX sources, column types) or actively worked around: its filter node had to be
// moved into the card header, its control rows reordered, and its widgets restyled.
//
// Declarative, like the rest of the app. The input names its table; the count, the
// info line and the pager are found inside the same card, so there is one attribute
// to keep in step instead of four:
//
//   <input data-filters="#users-table" data-filter-page-size="25">
//   <span class="table-filter__count"></span>      in the card header
//   <p class="table-filter__info"></p>             in the card footer
//   <nav class="table-filter__pager"></nav>        in the card footer
//
// Diacritics are folded, so "kovac" finds "Kovač" and "ziga" finds "Žiga". Slovenian
// names are full of them and nobody wants to type them into a search box.
global.tableFilter = {
  PAGE_WINDOW: 7, // most page buttons shown at once

  fold: function(s) {
    return (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  },

  init: function() {
    $('[data-filters]').each(function() {
      tableFilter.bind($(this));
    });
  },

  bind: function($input) {
    var $table = $($input.data('filters'));
    if($table.length === 0) return;

    var $scope = $input.closest('.card');
    var $rows = $table.find('tbody tr').not('.table-filter__empty');
    var $empty = $table.find('tbody .table-filter__empty');
    var $count = $scope.find('.table-filter__count');
    var $info = $scope.find('.table-filter__info');
    var $pager = $scope.find('.table-filter__pager');

    var perPage = parseInt($input.data('filterPageSize'), 10) || 25;
    var page = 1;

    // fold each row's text once, not on every keystroke
    $rows.each(function() {
      this.setAttribute('data-haystack', tableFilter.fold($(this).text().replace(/\s+/g, ' ')));
    });

    var render = function() {
      var q = tableFilter.fold($input.val()).trim();
      var matches = [];
      $rows.each(function() {
        if(q === '' || this.getAttribute('data-haystack').indexOf(q) >= 0) matches.push(this);
      });

      var pages = Math.max(1, Math.ceil(matches.length / perPage));
      if(page > pages) page = pages;
      var from = (page - 1) * perPage;
      var to = Math.min(from + perPage, matches.length);

      // one pass: everything hidden, then the current page's slice shown
      $rows.prop('hidden', true);
      for(var i = from; i < to; i++) matches[i].hidden = false;

      $empty.prop('hidden', matches.length > 0);
      if($count.length) {
        $count.text(matches.length === $rows.length ? matches.length
                                                    : matches.length + ' / ' + $rows.length);
      }
      if($info.length) {
        $info.text(matches.length === 0 ? ''
                                        : 'Prikazujem ' + (from + 1) + '–' + to + ' od ' + matches.length);
      }
      tableFilter.drawPager($pager, page, pages, function(p) {
        page = p;
        render();
      });
    };

    // a new query starts at the first page — staying on page 7 of a two-page result
    // is how a search looks broken
    $input.on('input', function() {
      page = 1;
      render();
    });
    render();
  },

  // Bootstrap 4 pagination markup, which the app already styles.
  drawPager: function($pager, page, pages, go) {
    if($pager.length === 0) return;
    $pager.empty();
    if(pages <= 1) return;

    var $ul = $('<ul class="pagination mb-0"></ul>');

    var item = function(label, target, opts) {
      opts = opts || {};
      var $li = $('<li class="page-item"></li>');
      if(opts.active) $li.addClass('active');
      if(opts.disabled) $li.addClass('disabled');
      var $a = $('<a class="page-link" href="#"></a>').html(label);
      if(!opts.disabled && !opts.active) {
        $a.on('click', function(e) { e.preventDefault(); go(target); });
      } else {
        $a.on('click', function(e) { e.preventDefault(); });
      }
      return $li.append($a);
    };

    // a window around the current page, so 20 pages do not become 20 buttons
    var half = Math.floor(tableFilter.PAGE_WINDOW / 2);
    var first = Math.max(1, Math.min(page - half, pages - tableFilter.PAGE_WINDOW + 1));
    var last = Math.min(pages, first + tableFilter.PAGE_WINDOW - 1);

    $ul.append(item('&laquo;', page - 1, { disabled: page === 1 }));
    if(first > 1) {
      $ul.append(item('1', 1));
      if(first > 2) $ul.append(item('…', null, { disabled: true }));
    }
    for(var p = first; p <= last; p++) $ul.append(item(String(p), p, { active: p === page }));
    if(last < pages) {
      if(last < pages - 1) $ul.append(item('…', null, { disabled: true }));
      $ul.append(item(String(pages), pages));
    }
    $ul.append(item('&raquo;', page + 1, { disabled: page === pages }));

    $pager.append($ul);
  }
};
